/* eslint-disable max-len */
/* eslint-disable quote-props */
/* eslint-disable @typescript-eslint/quotes */
export const X_ACCESS_TOKEN = 'x-access-token';
export const APPSFLYER_PROD_KEY = 'u4o28PYxcedYQW2ayxxrDf';
export const OK_SUPER = 'superOk';
export const IOS = 'ios';
export const ANDROID = 'android';
export const WEB = 'web';

export const APPSFLYER = {
    nonOrganic: 'Non-organic',
    onAppOpenAttribution: 'onAppOpenAttribution',
    referral: 'referral',
    whatsappSharing: 'whatsappSharing',
    appInviteOneLinkId: 'ef2T',
    iosAppId: '1600227958'
};

export const FIREBASE_TRACES = {
    homePageLaunch: 'homePageLaunch'
};

export const FIREBASE = {
    time: 0,
    android: 'AND',
    ios: 'IOS',
    configIsAlreadyActivated: 'config is already activated'
};

export const FIREBASE_KEY = {
    firebaseMasterData: 'firebaseMasterData',
    configVersion: 'configVersion'
};

export const STORAGE_KEYS = {
    firebaseConfig: 'firebaseConfig'
};
export const CLEVERTAP_CHANNELS = [
    { id: 'ok_marketing', name: 'Personal', description: 'Marketing Purpose', importance: 5, showBadge: true },
    { id: 'ok_delivery', name: 'Delivery Updates', description: 'Delivery Updates', importance: 5, showBadge: true }
];

export const HEADER_CONFIG = {
    noHeader: {
        visibility: false,
        addressSelection: false,
        cartIcon: false,
        subscriptionIcon: false,
        backButton: false,
        title: null,
        transparent: false,
        shareIcon: false,
        navigationUrl: null,
        subtitle: null,
    },
    home: {
        visibility: true,
        addressSelection: true,
        cartIcon: true,
        subscriptionIcon: true,
        backButton: false,
        title: null,
        transparent: false,
        shareIcon: false,
        navigationUrl: null,
        subtitle: null,
    },
    shop: {
        visibility: true,
        addressSelection: false,
        cartIcon: true,
        subscriptionIcon: true,
        backButton: false,
        title: 'Shop',
        subtitle: 'BY CATEGORIES',
        transparent: false,
        shareIcon: false,
        navigationUrl: null
    },
    search: {
        visibility: true,
        addressSelection: false,
        cartIcon: false,
        subscriptionIcon: false,
        backButton: true,
        title: null,
        transparent: false,
        shareIcon: false,
        navigationUrl: null,
        subtitle: null,
    },
    super: {
        visibility: true,
        addressSelection: false,
        cartIcon: true,
        subscriptionIcon: true,
        backButton: true,
        title: 'OK Super',
        transparent: false,
        shareIcon: false,
        navigationUrl: null,
        subtitle: null,
    },
    profile: {
        visibility: true,
        addressSelection: false,
        cartIcon: false,
        subscriptionIcon: false,
        backButton: false,
        title: 'My Profile',
        transparent: false,
        shareIcon: false,
        navigationUrl: null,
        subtitle: null,
    },
    awareness: {
        visibility: true,
        addressSelection: false,
        cartIcon: false,
        subscriptionIcon: false,
        backButton: true,
        title: 'About Us',
        transparent: false,
        shareIcon: false,
        navigationUrl: null,
        subtitle: null,
    },
    farmerList: {
        visibility: true,
        addressSelection: false,
        cartIcon: false,
        subscriptionIcon: false,
        backButton: false,
        title: 'Our Farmers',
        transparent: false,
        shareIcon: false,
        navigationUrl: null,
        subtitle: null,
    },
    farmerMessage: {
        visibility: true,
        addressSelection: false,
        cartIcon: false,
        subscriptionIcon: false,
        backButton: true,
        title: 'Leave a message',
        transparent: false,
        shareIcon: false,
        navigationUrl: null,
        subtitle: null,
    },
    farmerSelect: {
        visibility: true,
        addressSelection: false,
        cartIcon: false,
        subscriptionIcon: false,
        backButton: true,
        title: null,
        transparent: true,
        shareIcon: false,
        navigationUrl: null,
        subtitle: null,
    },
    order: {
        visibility: true,
        addressSelection: false,
        cartIcon: false,
        subscriptionIcon: false,
        backButton: true,
        title: 'My Orders',
        transparent: false,
        shareIcon: false,
        navigationUrl: null,
        subtitle: null,
    },
    cart: {
        visibility: true,
        addressSelection: false,
        cartIcon: true,
        subscriptionIcon: false,
        backButton: true,
        title: 'Shopping Cart',
        transparent: false,
        shareIcon: false,
        navigationUrl: null,
        subtitle: null,
    },
    orderDetails: {
        visibility: true,
        addressSelection: false,
        cartIcon: false,
        subscriptionIcon: false,
        backButton: true,
        title: '',
        transparent: false,
        shareIcon: false,
        navigationUrl: null,
        subtitle: null,
    },
    orderCancel: {
        visibility: true,
        addressSelection: false,
        cartIcon: true,
        subscriptionIcon: false,
        backButton: true,
        title: 'CancelOrder',
        transparent: false,
        shareIcon: false,
        navigationUrl: null,
        subtitle: null,
    },
    subscription: {
        visibility: true,
        addressSelection: false,
        cartIcon: false,
        subscriptionIcon: false,
        backButton: true,
        title: 'My Subscription',
        transparent: false,
        shareIcon: false,
        navigationUrl: null,
        subtitle: null,
    },
    editSubscription: {
        visibility: true,
        addressSelection: false,
        cartIcon: false,
        subscriptionIcon: false,
        backButton: true,
        title: 'Edit Subscription',
        transparent: false,
        shareIcon: false,
        navigationUrl: null,
        subtitle: null,
    },
    addSubscription: {
        visibility: true,
        addressSelection: false,
        cartIcon: false,
        subscriptionIcon: false,
        backButton: true,
        title: 'Add Subscription',
        transparent: false,
        shareIcon: false,
        navigationUrl: null,
        subtitle: null,
    },
    wallet: {
        visibility: true,
        addressSelection: false,
        cartIcon: false,
        subscriptionIcon: false,
        backButton: true,
        title: 'Wallet',
        transparent: false,
        shareIcon: false,
        navigationUrl: null,
        subtitle: null,
    },
    addMoney: {
        visibility: true,
        addressSelection: false,
        cartIcon: false,
        subscriptionIcon: false,
        backButton: true,
        title: 'Add Money',
        transparent: false,
        shareIcon: false,
        navigationUrl: null,
        subtitle: null,
    },
    addMoneyOk: {
        visibility: true,
        addressSelection: false,
        cartIcon: false,
        subscriptionIcon: false,
        backButton: true,
        title: 'History',
        transparent: false,
        shareIcon: false,
        navigationUrl: null,
        subtitle: null,
    },

    aboutUs: {
        visibility: true,
        addressSelection: false,
        cartIcon: false,
        subscriptionIcon: false,
        backButton: true,
        title: 'About Us',
        transparent: false,
        shareIcon: false,
        navigationUrl: null,
        subtitle: null,
    },
    frequentlyAskedQuestion: {
        visibility: true,
        addressSelection: false,
        cartIcon: false,
        subscriptionIcon: false,
        backButton: true,
        title: 'Frequently Asked Questions',
        transparent: false,
        shareIcon: false,
        navigationUrl: null,
        subtitle: null,
    },
    productDetail: {
        visibility: true,
        addressSelection: false,
        cartIcon: true,
        subscriptionIcon: false,
        backButton: true,
        title: null,
        transparent: true,
        shareIcon: true,
        navigationUrl: null,
        whiteArrowBack: true,
        subtitle: null,
    },
    termAndConditions: {
        visibility: true,
        addressSelection: false,
        cartIcon: false,
        subscriptionIcon: false,
        backButton: true,
        title: 'Terms and Conditions',
        transparent: false,
        shareIcon: false,
        navigationUrl: null,
        subtitle: null,
    },
    collectionListing: {
        visibility: true,
        addressSelection: false,
        cartIcon: true,
        subscriptionIcon: false,
        backButton: true,
        title: null,
        transparent: false,
        shareIcon: false,
        navigationUrl: null,
        subtitle: null,
    },
    superPlanDetail: {
        visibility: true,
        addressSelection: false,
        cartIcon: false,
        subscriptionIcon: false,
        backButton: true,
        title: 'OK Super Plan',
        transparent: false,
        shareIcon: false,
        navigationUrl: null,
        subtitle: null,
    },
    renewPlan: {
        visibility: true,
        addressSelection: false,
        cartIcon: false,
        subscriptionIcon: false,
        backButton: true,
        title: 'Renew Plan',
        transparent: false,
        shareIcon: false,
        navigationUrl: null,
        subtitle: null
    },
    superPaymentPage: {
        visibility: true,
        addressSelection: false,
        cartIcon: false,
        subscriptionIcon: false,
        backButton: true,
        title: 'Payment Page',
        transparent: false,
        shareIcon: false,
        navigationUrl: null,
        subtitle: null
    },
    paymentDetails: {
        visibility: true,
        addressSelection: false,
        cartIcon: false,
        subscriptionIcon: false,
        backButton: true,
        title: 'Payment Details',
        transparent: false,
        shareIcon: false,
        navigationUrl: null,
        subtitle: null
    },
    superPlanPurchased: {
        visibility: true,
        addressSelection: false,
        cartIcon: false,
        subscriptionIcon: false,
        backButton: true,
        title: 'Subscribe to OK Super',
        transparent: false,
        shareIcon: false,
        navigationUrl: null,
        subtitle: null
    },
    addAddress: {
        visibility: true,
        addressSelection: false,
        cartIcon: false,
        subscriptionIcon: false,
        backButton: true,
        title: null,
        transparent: true,
        shareIcon: false,
        navigationUrl: null,
        subtitle: null
    },
    addresses: {
        visibility: true,
        addressSelection: false,
        cartIcon: false,
        subscriptionIcon: false,
        backButton: true,
        title: 'Addresses',
        transparent: false,
        shareIcon: false,
        navigationUrl: null,
        subtitle: null
    },
    coupons: {
        visibility: true,
        addressSelection: false,
        cartIcon: false,
        subscriptionIcon: false,
        backButton: true,
        title: 'Apply Coupon',
        transparent: false,
        shareIcon: false,
        navigationUrl: null,
        subtitle: null
    },
    searchAddress: {
        visibility: true,
        addressSelection: false,
        cartIcon: false,
        subscriptionIcon: false,
        backButton: true,
        title: 'Search Address',
        transparent: true,
        shareIcon: false,
        navigationUrl: null,
        subtitle: null
    },
    farmDetails: {
        visibility: true,
        addressSelection: false,
        cartIcon: true,
        subscriptionIcon: false,
        backButton: true,
        title: 'Farm Hero',
        transparent: false,
        shareIcon: false,
        navigationUrl: null,
        whiteArrowBack: true,
        subtitle: null
    },
    productDetails: {
        visibility: true,
        addressSelection: false,
        cartIcon: true,
        subscriptionIcon: false,
        backButton: true,
        title: null,
        transparent: true,
        shareIcon: true,
        navigationUrl: null,
        whiteArrowBack: true,
        subtitle: null
    },
    productList: {
        visibility: true,
        addressSelection: false,
        cartIcon: true,
        subscriptionIcon: false,
        backButton: true,
        title: null,
        transparent: true,
        shareIcon: true,
        navigationUrl: null,
        whiteArrowBack: true,
        subtitle: null
    },
    productLists: {
        visibility: true,
        addressSelection: false,
        cartIcon: false,
        subscriptionIcon: false,
        backButton: true,
        title: '',
        transparent: false,
        shareIcon: true,
        navigationUrl: null,
        subtitle: null
    },
    productTestCase: {
            visibility: true,
            addressSelection: false,
            cartIcon: false,
            subscriptionIcon: false,
            backButton: true,
            title: '',
            transparent: false,
            shareIcon: true,
            navigationUrl: null,
            subtitle: null
        },
        shopCategory: {
            visibility: true,
            addressSelection: true,
            cartIcon: true,
            subscriptionIcon: false,
            backButton: false,
            title: null,
            transparent: false,
            shareIcon: false,
            navigationUrl: null,
            subtitle: null
        },
        farmGallery: {
            visibility: true,
            addressSelection: false,
            cartIcon: false,
            subscriptionIcon: false,
            backButton: true,
            title: 'Farm Gallery',
            transparent: false,
            shareIcon: false,
            navigationUrl: null,
            subtitle: null
        },
        farmImage: {
            visibility: true,
            addressSelection: false,
            cartIcon: false,
            subscriptionIcon: false,
            backButton: true,
            title: null,
            transparent: true,
            shareIcon: false,
            navigationUrl: null,
            whiteArrowBack: true,
            subtitle: null
        },
        addDelivery: {
            visibility: true,
            addressSelection: false,
            cartIcon: true,
            subscriptionIcon: false,
            backButton: true,
            title: 'Choose a delivery address',
            transparent: false,
            shareIcon: false,
            navigationUrl: null,
            subtitle: null
        },
        deleteDelivery: {
            visibility: true,
            addressSelection: false,
            cartIcon: true,
            subscriptionIcon: false,
            backButton: true,
            title: 'Choose a delivery address',
            transparent: false,
            shareIcon: false,
            navigationUrl: null,
            subtitle: null
        },
        deliveryDetails: {
            visibility: true,
            addressSelection: false,
            cartIcon: true,
            subscriptionIcon: false,
            backButton: true,
            title: '',
            transparent: false,
            shareIcon: false,
            navigationUrl: null,
            subtitle: null
        },
        referEarn: {
            visibility: true,
            addressSelection: false,
            cartIcon: true,
            subscriptionIcon: false,
            backButton: true,
            title: 'Refer and Earn',
            transparent: false,
            shareIcon: false,
            navigationUrl: null,
            subtitle: null
        },
        saveCard: {
            visibility: true,
            addressSelection: false,
            cartIcon: false,
            subscriptionIcon: false,
            backButton: true,
            title: 'Save Card Details',
            transparent: false,
            shareIcon: false,
            navigationUrl: null,
            subtitle: null
        },
     };

    export const PAYMENT_SCREEN_CONTENT: any = {
        walletRecharge: {
            success: {
                img: '../../assets/images/payment-status/payment_success.gif',
                header: '<span class="payment_success">Top-up successful</span>',
                subHeader: 'Hurray! Your transaction is processed successfully.',
                buttonText: 'Done',
                redirect: '/profile/wallet',
            },
            error: {
                img: '../../assets/images/payment-status/payment_error.gif',
                header: '<span class="payment_error">Oops!</span>',
                subHeader: 'There was an error in processing the transaction.',
                buttonText: 'Try again!',
                redirect: '',
            },
            pending: {
                img: '../../assets/images/payment-status/payment_pending.gif',
                header: '<span class="payment_pending">Have Patience!</span>',
                subHeader: 'We\'re trying to confirm your payment status. Check your transaction history for an update.',
                buttonText: 'Done',
                redirect: '/profile/wallet',
            }
        },
        superNewBuy: {
            success: {
                img: '../../assets/images/payment-status/payment_success.gif',
                header: '<span class="payment_success">Congratulations!</span>',
                subHeader: 'You\'re all set to save with OK Super.',
                buttonText: 'Done',
                redirect: '/ok-super',
            },
            error: {
                img: '../../assets/images/payment-status/payment_error.gif',
                header: '<span class="payment_error">Oops!</span>',
                subHeader: 'There was an error in processing the transaction.',
                buttonText: ' Try again!',
                redirect: '/ok-super',
            },
            pending: {
                img: '../../assets/images/payment-status/payment_pending.gif',
                header: '<span class="payment_pending">We\'re Sorry!</span>',
                subHeader: 'We\'re trying to confirm your payment status. Check your transaction history for an update.',
                buttonText: 'Done',
                redirect: '/ok-super',
            }
        },
        superRenewBuy: {
            success: {
                img: '../../assets/images/payment-status/payment_success.gif',
                header: '<span class="payment_success">OK Super is active again!</span>',
                subHeader: 'Congratulations! You\'ve just renewed your OK Super plan',
                buttonText: 'Done',
                redirect: '/ok-super',
            },
            error: {
                img: '../../assets/images/payment-status/payment_error.gif',
                header: '<span class="payment_error">Oops!</span>',
                subHeader: 'There was an error in processing the transaction.',
                buttonText: ' Try again!',
                redirect: '/ok-super',
            },
            pending: {
                img: '../../assets/images/payment-status/payment_pending.gif',
                header: '<span class="payment_pending">Don\'t Worry</span>',
                subHeader: 'We\'re trying to confirm your payment status. Check your transaction history for an update.',
                buttonText: 'Done',
                redirect: '/ok-super',
            }
        },
        orderRecharge: {
            success: {
                img: '../../assets/images/payment-status/payment_success.gif',
                header: '<span class="payment_success">Order Placed Successfully</span>',
                subHeader: 'You\'re a step closer to transforming your conventional kitchen into an OK India',
                buttonText: 'Done',
                redirect: '/home',
            },
            error: {
                img: '../../assets/images/payment-status/payment_error.gif',
                header: '<span class="payment_error">Oops!</span>',
                subHeader: 'There was an error in processing the transaction.',
                buttonText: 'Try again!',
                redirect: '',
            },
            pending: {
                img: '../../assets/images/payment-status/payment_pending.gif',
                header: '<span class="payment_pending">Don\'t Worry</span>',
                subHeader: 'We\'re trying to confirm your payment status. Check your transaction history for an update.',
                buttonText: 'Done',
                redirect: '',
            }
        }
    };

    export const FIREBASE_MASTER_DATA = {
        "minimumRechargeAmount": 250,
        "firebaseFetchVersion": "0.0.35",
        "referral": true,
        "referralText": "Invite a friend to OK India and they will receive 25% cashback on their first wallet top-up recharge, while you will receive 10% cashback in your wallet.",
        "showSuperPlanOnHomePage": false,
        "hideWhyUs": true,
        "subscriptionDiscount": 1,
        "subscriptionPlan": {
            "2500": 11,
            "5000": 22,
            "10000": 33
        },
        "promoBanner": "https://media.okindia.com/home_page_v4.gif",
        "startDateOffSet": 1,
        "showWhyUs": false,
        "deliveryAmount": 0,
        "foodWalletPayment": false,
        "payWithSodexo": true,
        "faq": "<div class='ion-margin content-margin-main'> <h4 style=' font-family: math; font-weight: 800; '>BRAND RELATED</h4> <h6 class='sub-heading'> 1. How do I trust whether OK India products are Organic?</h6> <p class='para'> OK India is certified organic by SGS India Pvt. Ltd. (NPOP/NAB/009). The Indian market is full of players who are not certified organic, and we are certainly not one of them.</p> <p class='para'>Just like 'Teja', always check “Mark kidhar hai ?“</p> <ion-text class='para'>We are committed to providing you and your family with 100% organic food, and we strictly say NO to pesticides, artificial fertilizers, insecticides, preservatives, or any other form of chemicals.</ion-text> </div> <div class='ion-margin content-margin-main'> <h6 class='sub-heading'>2. Why should I switch to organic?</h6> <p class='para'>We have a million reasons for you to switch organic.</p> <p class='para'> Here are a few of the reasons why you should switch to organic: </p> <p class='para'> (i) Organic food is not genetically modified and is grown naturally without synthetic chemicals. </p> <p class='para'> (ii) Organic food does not deplete the nutrition content present in the food, hence helping you become healthier each day. </p> <p class='para'> (iii) Organic food supports the soil, environment, and the planet. </p> <p class='para'> (iv) Organic food does not let unnecessary toxins from pesticides and fertilizer enter your body. </p> </div> <div class='ion-margin content-margin-main'> <h4 style='font-size:22px; font-weight: 600;'>ORDER & PAYMENT RELATED</h4> <h6 class='sub-heading'>1. Where can I find the details of my order? </h6> <p class='para'> You can find the details of your order in the 'My Order' section in your profile. </p> <h6 class='sub-heading'>2. Why do I need to Top-Up the wallet? </h6> <p class='para'>OK India is designed to offer you a seamless shopping experience and our wallet is key of that. Once you add money to the wallet you don't need to go through the hassle of payment checkouts on every order.</p> <h6 class='sub-heading'>3. If I don't need to check out, how will I place my daily order? </h6> <ion-text class='para'>Our wonderful feature comes in handy for just this situation! All you have to do is add whatever you need in the basket throughout the day up till midnight. We have an automatic checkout of all items in the basket at midnight, everyday.</ion-text> <h6 class='sub-heading'>4. Is there an expiry for my wallet balance?</h6> <ion-text class='para'>There is no expiry for your wallet balance. Once the money is credited to your OK India wallet, it remains until used.</ion-text> <h6 class='sub-heading'>5. What are the modes of payment available for wallet recharge? </h6> <p class='para'>You can use the following mentioned payment methods:</p> <p class='para'>(i) Pay using, Netbanking.</p> <p class='para'>(ii) Credit and debit cards (VISA / Mastercard / Rupay).</p> <p class='para'>(iii) UPI- PayTM, Google Pay, PhonePay.</p> <h6 class='sub-heading'>6. When will I receive my order?</h6> <ion-text class='para'>You will receive everything you have added to your cart before 7AM next morning at your doorstep.</ion-text> </div> <div class='ion-margin  content-margin-main'> <h4 style='font-size:22px; font-weight: 600;'>PACKAGING RELATED</h4> <h6 class='sub-heading'>1. Are your products packaged in plastic bags?</h6> <p class='para'> We do not use non-recyclable plastics. We use corn starch bags and pouches for packaging the products, as it is more environmentally friendly and sustainable. </p> <h6 class='sub-heading'> 2. What is the best way to store the products after receiving the package? </h6> <p class='para'> We deliver the products after proper sanitization and quality checks. After receiving the product, make sure to follow the storage instructions given on the product page. </p> <h6 class='sub-heading'>3. How are the fruits and vegetables packed?</h6> <p class='para'> The fresh fruits, vegetables, and grocery items are hand-picked and hand-packed after proper sanitization in our corn starch bags and boxes. We ensure hygienic and careful handling of our products. </p> <h6 class='sub-heading'>4. What do I do with the packaging?</h6> <p class='para'> You can re-use our corn-starch bags, boxes, pouches, and jars for your personal use. You can return the cardboard boxes back to us and we'll recycle it for you. You can also send the jars back with our delivery executives while making the next stop and get a refund for the same. </p> </div> <div class='ion-margin  content-margin-main'> <h4 style='font-size:22px; font-weight: 600;'>PRODUCT RELATED</h4> <h6 class='sub-heading'> 1. Why is there a colour variation inside my fruits/vegetables? </h6> <p class='para'> It is entirely normal to have a different colour variation, as the farmers use various seeds when grown. For Example, Pomegranate has two varieties of seeds: Satin and Sindoori; Both vary in size and colour but deliver richness in quality and nutritional value. </p> <h6 class='sub-heading'>2. Why is my vegetable spoiled from the inside?</h6> <p class='para'> As our farmers do not use pesticides, pests and insects may attack the vegetables and fruits. Do not worry; we have your back with our no questions asked refund policy. All you have to do is, send us an image of the rotten/infested vegetables/fruits to us, and we will replace your order. </p> <h6 class='sub-heading'>3. Why are my vegetables dirty?</h6> <p class='para'> Since all of our products are organically produced and sent straight from the farms without treating them with chemicals or preservatives, you can wash it once before use, and you are good to go. </p> <h6 class='sub-heading'> 4. What do you mean by chemical/ pesticide-free? </h6> <p class='para'> Chemical/Pesticide-free produce means no synthetic chemicals have been used to produce that particular crop. Organic farming forbids the use of any synthetic chemicals and fertilisers, and we, along with our farms, strictly abide by it </p> <h6 class='sub-heading'>5. What does 'Certified Organic' mean?</h6> <p class='para'> 'Certified Organic' means the produce has been grown with strict adherence to the standards set and regularly monitored by the certification body. Monitoring includes periodic inspections of the farm, processing facilities, detailed record-keeping, regular checks to monitor the residual effect of any chemicals below maximum permissible levels, and regular soil and water testing to ensure that farmers, collection centers, and handlers meet the set standards. </p> </div> <div class='ion-margin  content-margin-main'> <h4 style='font-size:22px; font-weight: 600;'>TRACEABILITY RELATED</h4> <h6 class='sub-heading'>1. What is traceability?</h6> <p class='para'> When it comes to organic food, there's a lot of ambiguity around the authenticity; OK India offers you complete transparency. When we say transparency, we mean you will have access to all the information about the food that lands on your plate (farm location, certification, pictures of the processes being followed at the farm, harvesting pictures, and videos). </p> <h6 class='sub-heading'>2. How does traceability benefit me?</h6> <p class='para'> There are a lot of market players claiming to provide you with organic food, but how do you make sure the food is actually organic? At OK India, when you pay for organic food, be rest assured of getting nothing else, but 100% Certified Organic Food. </p> <h6 class='sub-heading'> 3. How can I access information about the product that is delivered at my doorstep? </h6> <p class='para'> Our products come with a QR Code; you simply have to scan the QR code and access all the information from harvest time, farm location to the organic certificate and much more about that product. </p> </div> <div class='ion-margin  content-margin-main'> <h4 style='font-size:22px; font-weight: 600;'>DELIVERY RELATED</h4> <h6 class='sub-heading'> 1. Which products on your site qualify for free delivery? </h6> <p class='para'> OK India offers free delivery on all orders above ₹100. </p> <h6 class='sub-heading'>2. What is the minimum price order?</h6> <p class='para'> There is no minimum size/prize for ordering. We offer free delivery on orders above ₹100, whereas orders below ₹100 have a delivery fee of ₹50. </p> <h6 class='sub-heading'>3. Do you have same day delivery? </h6> <p class='para'> No, we don't offer same day delivery, you can order till midnight and get it delivered to your doorsteps before 8am. </p> <h6 class='sub-heading'>4. Where can my items be shipped for free?</h6> <p class='para'> Free shipping applies to shipping addresses within. Gurugram. </p> </div> <div class='ion-margin  content-margin-main'> <h4 style='font-size:22px; font-weight: 600;'> CANCELLATION, RETURN, REFUND, AND RESCHEDULE RELATED </h4> <h6 class='sub-heading'>1. How do I cancel the order I have placed?</h6> <p class='para'>Our policy is that orders placed cannot be cancelled, as we have an automated checkout system. If you decide you don't want to place an order, then you have to remove the products from your cart before midnight. </p> <h6 class='sub-heading'>2. What if some products are damaged or spoiled?</h6> <p class='para'> OK India highly efficient delivery system guarantees that your items will be delivered to you in pristine condition. However, if there is a human error on our part in a highly unlikely scenario, we ask you to please share pictures of the damaged or defective product so that we can proceed further with a replacement or refund. </p> <h6 class='sub-heading'>3. Can I cancel my OK Super plan?</h6> <p class='para'> You can't cancel your membership once enrolled.</p> <h6 class='sub-heading'>4. Where will I receive my refund? </h6> <p class='para'> Your refund money will automatically be credited to your OK India Wallet. If you require any other assistance, contact our support team at contactus@okindia.com/ +91-8448871006. </p> <h6 class='sub-heading'> 5. By when can I expect the refund money credited to my OK India Wallet? </h6> <p class='para'> Your refund money will be instantly credited to your OK India Wallet. </p> <h6 class='sub-heading'>6. Can I get refund for my wallet recharge? </h6> <p class='para'>If you have recharged you wallet than it cannot be returned or transferred to your bank account.</p> </div> <div class='ion-margin  content-margin-main'> <h4 style='font-size:22px; font-weight: 600;'>WHAT IS OK ASSURED ?  </h4> <p class='para'> OK Assured is the purest and most trustable badge of assurance for our daily essentials.This badge guarantees advantages such as live tracking, organic certification, end-to-end testing and authenticity. Goods having this label have undergone multilevel testing for soil and product purity. “Now eat organic without any hesitation”. </p> <h6 class='sub-heading'>How it is beneficial ? </h6> <p class='para'> It has undergone three levels of testing, namely farm level, batch level, and warehouse quality testing, which indicates the purity of the land and product. </p> <h6 class='sub-heading'>How does choose your farmer works?  </h6> <p class='para'> At OK India, we give you the option of selecting your own farmers based on their ratings, certificates, tests, and other factors. </p> </div>",
        "superOkPlan": {
            "beginner": [
                {
                    "id": 1,
                    "parentCode": "20P",
                    "name": "Beginner",
                    "value": 99,
                    "maxDiscount": "Infinite",
                    "validity": 30,
                    "discountPercentage": 10
                }
            ],
            "committed": [
                {
                    "id": 2,
                    "parentCode": "30P",
                    "name": "Committed",
                    "value": 199,
                    "maxDiscount": "Infinite",
                    "validity": 30,
                    "discountPercentage": 20
                }
            ]
        },
        "walletOffer": {
            "active": false,
            "header": "Flat ₹250 cashback on 1st wallet recharge",
            "subHeader": "Applicable on a recharge of ₹1000 and above"
        },
        "deliveryCharges": "Free Delivery on orders above ₹100 in Gurugram",
        "disclaimer": "<ul class='ion-no-margin'> <li> Product image shown is for representation purpose only, the actual product may vary based on season, produce & availability. </li> <li> Please note that the item(s) in this product may vary slightly in size and weight. Hence, the actual weight of the product delivered can have a small variance. </li> </ul>",
        "referralShareText": "Hey, I use OK India regularly to order my daily essentials with an assured 7AM delivery, it's super convenient and certified organic. Use my referral code #CODE to signup on OK India and get 25% cashback on your first wallet recharge.",
        "whichTypeOfSuperShown": "high_light",
        "superMaxDiscount": 0.8,
        "inAppPushNotification": {
            "navigateUrl": "product-list/product-assured",
            "imageUrl": "https://media.okindia.com/ok_assured_banner_pop.png"
        },
        "homeTopBanner": {
            "navigateUrl": "product-list/product-assured",
            "imageUrl": "https://media.okindia.com/vendor/media-pool/2a9fm_ok_assured_2x.png"
        }
    };
    export const SHARE_SUBJECT = 'Refer';
    export const INVITE_CHOOSER_TITLE = 'Share OK India with...';
